var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-row gap-x-2 items-center"},[_c('div',{attrs:{"id":_vm.donutId}}),(_vm.displayMode === 'beside')?_vm._t("donut-id"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }